// Curated reviews shown on every city detail page.
// Structured for future Google Places API swap-in: keep the same shape.
// Placeholder: replace `source` with "google-places" and wire the API to
// bc_reviews_service in the backend once GOOGLE_PLACES_API_KEY is added.

export const REVIEWS = [
  {
    author: "Alex R.",
    role: "Property Manager · Downtown Vancouver",
    rating: 5,
    text: "Switched from a national chain to Maze last year — the difference in officer retention alone was worth it. Same faces every month, and their morning reports actually get read.",
    source: "curated",
  },
  {
    author: "Priya S.",
    role: "Site Supervisor · Surrey construction",
    rating: 5,
    text: "Copper theft dropped to zero the first month. Their mobile patrol logs are so detailed our insurance underwriter asked how we did it.",
    source: "curated",
  },
  {
    author: "Marc L.",
    role: "Operations Director · Kootenay mine",
    rating: 5,
    text: "FIFO rotation done right. Officers are pre-cleared for camp, ERP-oriented, and integrate with our safety team on day one. Would recommend to any BC operator.",
    source: "curated",
  },
  {
    author: "Sarah T.",
    role: "Event Producer · Kelowna",
    rating: 5,
    text: "AST-certified team, clean radio comms, and the pre-event walk-through caught two egress issues our venue missed. Booked them for every summer event since.",
    source: "curated",
  },
  {
    author: "James O.",
    role: "Strata Council President · Burnaby",
    rating: 5,
    text: "Overnight patrol reports are timestamped and photo-tagged. Council actually looks forward to reading them at the monthly meeting.",
    source: "curated",
  },
  {
    author: "Devon K.",
    role: "Retail Director · Vancouver Island",
    rating: 5,
    text: "Loss prevention officers know the BC Trespass Act cold. Court-ready statements, respectful with customers, and zero incidents of over-reach. Rare combination.",
    source: "curated",
  },
];
